(() => {
  const grids = new WeakMap();

  function observeGrid(grid) {
    if (grids.has(grid)) return;

    let productCard;
    let frame;

    const measure = () => {
      frame = null;
      const nextCard = grid.querySelector(':scope > product-card');

      if (nextCard !== productCard) {
        if (productCard) resizeObserver.unobserve(productCard);
        productCard = nextCard;
        if (productCard) resizeObserver.observe(productCard);
      }

      if (!productCard) {
        grid.style.removeProperty('--collection-product-card-height');
        return;
      }

      const height = productCard.getBoundingClientRect().height;
      if (height > 0) {
        grid.style.setProperty('--collection-product-card-height', `${height}px`);
      }
    };

    const schedule = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(measure);
    };

    const resizeObserver = new ResizeObserver(schedule);
    const mutationObserver = new MutationObserver(schedule);
    mutationObserver.observe(grid, { childList: true });
    grids.set(grid, { resizeObserver, mutationObserver });
    schedule();
  }

  function observeAll(root = document) {
    if (root.matches?.('.collection__grid')) observeGrid(root);
    root.querySelectorAll?.('.collection__grid').forEach(observeGrid);
  }

  const pageObserver = new MutationObserver((mutations) => {
    mutations.forEach(({ addedNodes }) => {
      addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) observeAll(node);
      });
    });
  });

  const init = () => {
    observeAll();
    pageObserver.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', ({ target }) => observeAll(target));
})();
